var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = {
            get passive() {
                passiveSupported = true;
                return true;
            }
        };
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
export var isPassiveSupported = passiveSupported;
